import React from "react";

import service1Img from "images/14.jpg";
import service2Img from "images/gallery/04.jpeg";
import service3Img from "images/15.jpg";
import service4Img from "images/16.jpg";
import service5Img from "images/gallery/09.jpeg";
import service6Img from "images/13.jpg";
import service7Img from "images/gallery/03.jpeg";

const Services = () => {
	return (
		<div
			id="services"
			className="done-project-area rts-section-gap"
			style={{ background: "#f7f7f7" }}>
			<div className="container mb--150">
				<div className="row">
					<div className="col-lg-12">
						<div className="title-area-center">
							<p className="pre">I servizi in dettaglio</p>
							<h2 className="title">
								Proponiamo le Migliori Soluzioni <br />
								<span>Sul Mercato</span>
							</h2>
						</div>
					</div>
				</div>
				<div className="row mt--30 g-24">
					<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
						<div className="single-cleaning-project">
							<div className="thumbnail">
								<img src={service1Img} alt="Controsoffitti in cartongesso a Codogno" />
							</div>
							<div className="project-content-area">
								<h5 className="title">Controsoffitti</h5>

								<p className="disc">
									Soluzioni in cartongesso e materiali tecnici per controsoffittature estetiche e
									funzionali, controsoffitti ispezionabili in pannelli di fibra minerale, gesso
									alleggerito e lana di roccia, controsoffitti antincendio, antiumidità e
									acustici.
								</p>
							</div>
						</div>
					</div>
					<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
						<div className="single-cleaning-project">
							<div className="thumbnail">
								<img src={service2Img} alt="Pareti divisorie in cartongesso a Codogno" />
							</div>
							<div className="project-content-area">
								<h5 className="title">Pareti Divisorie</h5>

								<p className="disc">
									Pareti leggere, performanti e su misura per ogni ambiente. Pareti in cartongesso
									standard, antincendio, acustiche o in calcio fibrosilicato.
								</p>
							</div>
						</div>
					</div>
					<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
						<div className="single-cleaning-project">
							<div className="thumbnail">
								<img src={service3Img} alt="Contropareti in cartongesso a Codogno" />
							</div>
							<div className="project-content-area">
								<h5 className="title">Contropareti</h5>

								<p className="disc">
									Rivestimenti murari per isolamento e rifinitura. Contropareti in cartongesso,
									contropareti tecniche antincendio, antiumidità e acustiche. Contropareti esterne
									in fibrocemento o gesso fibrorinforzato.
								</p>
							</div>
						</div>
					</div>
					<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
						<div className="single-cleaning-project">
							<div className="thumbnail">
								<img src={service4Img} alt="Rivestimenti speciali in cartongesso a Codogno" />
							</div>
							<div className="project-content-area">
								<h5 className="title">Rivestimenti speciali</h5>

								<p className="disc">
									Finiture decorative e protettive per elementi strutturali. Rivestimenti in
									cartongesso per camini e pilastri e rivestimenti antincendio certificati.
								</p>
							</div>
						</div>
					</div>
					<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
						<div className="single-cleaning-project">
							<div className="thumbnail">
								<img src={service5Img} alt="Elementi architettonici in cartongesso a Codogno" />
							</div>
							<div className="project-content-area">
								<h5 className="title">Elementi Architettonici in Cartongesso</h5>

								<p className="disc">
									Design su misura per valorizzare ambienti interni. Creazione di nicchie,
									velette, gole, finte travi e mensole in cartongesso.
								</p>
							</div>
						</div>
					</div>
					<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
						<div className="single-cleaning-project">
							<div className="thumbnail">
								<img src={service6Img} alt="Isolamento e posa materiali a Codogno" />
							</div>
							<div className="project-content-area">
								<h5 className="title">Isolamento e Posa Materiali</h5>

								<p className="disc">
									Tecniche e materiali per il comfort termico e acustico. Posa pannelli in
									poliuretano per isolamento termico, lana di roccia, lana di vetro e lana
									minerale per isolamento termico e acustico. Botole ispezionabili rasomuro, telai
									e falsotelai in cartongesso.
								</p>
							</div>
						</div>
					</div>
					<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
						<div className="single-cleaning-project">
							<div className="thumbnail">
								<img src={service7Img} alt="Lavorazioni speciali in cartongesso a Codogno" />
							</div>
							<div className="project-content-area">
								<h5 className="title">Lavorazioni Speciali</h5>

								<p className="disc">
									Interventi tecnici e personalizzazioni. Tamponamenti, fori e tagli per faretti,
									strip LED e impianti. Soluzioni su misura per ogni ambiente e progettazione
									dedicata.
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Services;
